import { useMutation, useQuery } from '@tanstack/react-query';
import { getFormConfig, postFormSubmission } from './formService';

/**
 * Form configuration query hook
 * @param {string} formUrl - Form URL from API or page action
 * @param {object} [params={}] - Query params forwarded to getFormConfig / api.get
 * @param {object} [options={}] - React Query options (merged after queryKey / queryFn)
 * @returns {import('@tanstack/react-query').UseQueryResult<ApiFormResponse, Error>}
 */
export const useFormConfig = (formUrl, params = {}, options = {}) => {
  /** @type {import('@tanstack/react-query').UseQueryOptions<ApiFormResponse, Error>} */
  const queryOptions = {
    queryKey: ['formConfig', formUrl, params],
    queryFn: () => getFormConfig(formUrl, params),
    enabled: Boolean(formUrl),
    ...options,
  };

  return useQuery(queryOptions);
};

/**
 * Form submission mutation hook
 * @param {object} [options] - The mutation options
 * @returns {import('@tanstack/react-query').UseMutationResult<ApiFormPostResponse, Error, {sendFormUrl: string, transformedData: ApiFormPostRequestBody}, unknown>} The form submission mutation
 */
export const useFormSubmitMutation = (options = {}) => useMutation({
  mutationFn: ({ sendFormUrl, transformedData }) => postFormSubmission(sendFormUrl, transformedData),
  ...options,
});
